function historySiginTime(time) {
  const date = new Date(time);
  const year = `${date.getFullYear()}-`;
  const month = `${date.getMonth() + 1}-`;
  const day = `${date.getDate()} `;
  const hour = date.getHours() ? `${date.getHours()}:` : '';
  const minute = date.getMinutes() ? `${date.getMinutes()}:` : '';
  const seconds = date.getSeconds() ? `${date.getMinutes()}` : '';
  return `${year}${month}${day}${hour}${minute}${seconds}`;
}

function timeago(dateTimeStamp){   //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  const minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;
  const halfamonth = day * 15;
  const month = day * 30;
  const now = new Date().getTime();   //获取当前时间毫秒
  let result = '';
  const diffValue = now - dateTimeStamp;//时间差

  if(diffValue < 0){
      return;
  }
  const minC = diffValue/minute;  //计算时间差的分，时，天，周，月
  const hourC = diffValue/hour;
  const dayC = diffValue/day;
  const weekC = diffValue/week;
  const monthC = diffValue/month;
  if(monthC >= 1 && monthC <= 3){
      result = " " + parseInt(monthC) + "月前"
  }else if(weekC >= 1 && weekC <= 3){
      result = " " + parseInt(weekC) + "周前"
  }else if(dayC >= 1 && dayC <= 6){
      result = " " + parseInt(dayC) + "天前"
  }else if(hourC >= 1 && hourC <= 23){
      result = " " + parseInt(hourC) + "小时前"
  }else if(minC >= 1 && minC <= 59){
      result =" " + parseInt(minC) + "分钟前"
  }else if(diffValue >= 0 && diffValue <= minute){
      result = "刚刚"
  }else {
    const datetime = new Date();
      datetime.setTime(dateTimeStamp);
      const Nyear = datetime.getFullYear();
      const Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      const Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      const Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
      const Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
      const Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
      result = Nyear + "-" + Nmonth + "-" + Ndate
  }
  return result;
}



// 时间转换
function createTime(timeVal = +new Date()) {
  const date = new Date(timeVal + (8 * 3600 * 1000)); // 北京时间额外增加八个时区
  return date.toJSON().substr(0, 19).replace('T', ' ');
}
function filterHTMLTag(msg) {
  var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
  msg = msg.replace(/[|]*\n/, '') //去除行尾空格
  msg = msg.replace(/&npsp;/ig, ''); //去掉npsp
  return msg;
}
function setCookie(name,value)
{
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*1000);
  document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
}
function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          console.log(c)
          while (c.charAt(0) == ' ') c = c.substring(1);
          if (c.indexOf(name) != -1){
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
export default {
  historySiginTime,
  createTime,
  filterHTMLTag,
  timeago,
  setCookie,
  getCookie,
};



// WEBPACK FOOTER //
// ./src/common/methods.js